module.exports = __webpack_public_path__ + "img/c05_unitvillager_Normal_ua.dffaa829.webp";